import React from 'react';
import { Link } from 'react-router-dom';
import './css/Home.css';

function Home() {
  return (
    <div className="home">
      <img src="/vyral.png" alt="VyralMining Logo" className="logo" />
      <h2>Welcome to VyralMining</h2>
      <p>
        Start mining Bitcoin using our high-performance ASIC mining rigs. Enter your wallet and start earning.
      </p>
      <Link to="/start-mining" className="home-start-button">Start Mining</Link>
    </div>
  );
}

export default Home;